var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    fill: "none",
    viewBox: "0 0 9 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9F9F9F",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M0 4H5.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9F9F9F",
    fillRule: "evenodd",
    d: "M4.40002 0L9.00002 4L4.40002 8V0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.ee8b880488c1a60e86872ce0be0eb64e.svg";
export { ForwardRef as ReactComponent };